/**
 * CinematicReveal Component
 * Phase 3.4 - Premium reveal animation for completed readings
 */

import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { Hand } from 'lucide-react';

const CinematicReveal = ({ lang = 'tr', onSkip }) => {
  return (
    <motion.div
      className="cinematic-reveal-overlay"
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      data-testid="cinematic-reveal"
    >
      <div className="reveal-content">
        <motion.div
          className="reveal-blur-layer"
          initial={{ backdropFilter: 'blur(20px)' }}
          animate={{ backdropFilter: 'blur(0px)' }}
          transition={{ duration: 2.5, ease: 'easeOut' }}
        />
        
        <motion.div
          className="reveal-text"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <Hand size={48} className="reveal-icon" />
          <h2>{lang === 'tr' ? 'Okumanız Hazır' : 'Your Reading is Ready'}</h2>
          <p>{lang === 'tr' ? 'Avuç içinizin hikâyesini keşfedin...' : 'Discover the story of your palm...'}</p>
        </motion.div>
        
        <button
          className="skip-reveal-btn"
          onClick={onSkip}
          data-testid="skip-reveal"
        >
          {lang === 'tr' ? 'Atla' : 'Skip'}
        </button>
      </div>
    </motion.div>
  );
};

CinematicReveal.propTypes = {
  lang: PropTypes.string,
  onSkip: PropTypes.func.isRequired
};

export default CinematicReveal;
